// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_execution_result_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { Side } from "../../bfftypes/v1/side_pb";
import { file_bfftypes_v1_side } from "../../bfftypes/v1/side_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/bidding_execution_result_model.proto.
 */
export const file_bffuser_v1_bidding_execution_result_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_side, file_google_type_date, file_google_type_decimal]);

/**
 * BiddingExecutionResultStatusSelection は約定結果タブのステータスフィルタの選択。 statuses は
 * 約定結果 CSV に出る行の区分、 unarrived_statuses は未着の札の件数に数える区分 (AC-BSP-115:
 * 件数はフィルタ適用後)。 それぞれ空 = 該当なし。
 *
 * @generated from message bffuser.v1.BiddingExecutionResultStatusSelection
 */
export type BiddingExecutionResultStatusSelection = Message<"bffuser.v1.BiddingExecutionResultStatusSelection"> & {
  /**
   * @generated from field: repeated bffuser.v1.BiddingExecutionResultStatus statuses = 1;
   */
  statuses: BiddingExecutionResultStatus[];

  /**
   * @generated from field: repeated bffuser.v1.BiddingExecutionResultUnarrivedStatus unarrived_statuses = 2;
   */
  unarrivedStatuses: BiddingExecutionResultUnarrivedStatus[];
};

/**
 * Describes the message bffuser.v1.BiddingExecutionResultStatusSelection.
 * Use `create(BiddingExecutionResultStatusSelectionSchema)` to create a new message.
 */
export const BiddingExecutionResultStatusSelectionSchema: GenMessage<BiddingExecutionResultStatusSelection> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_execution_result_model, 0);

/**
 * BiddingExecutionResultWorkflowSelection は約定結果タブのワークフローのフィルタの選択 (AC-BSP-037)。
 * workflow_ids の札と、 include_no_workflow ならワークフローを経由せずに作った札を選ぶ。 通常入札は
 * 札の、 ブロック入札はグループのワークフローで判定し、 CSV の行と未着の件数の両方に効く (AC-BSP-115)。
 *
 * @generated from message bffuser.v1.BiddingExecutionResultWorkflowSelection
 */
export type BiddingExecutionResultWorkflowSelection = Message<"bffuser.v1.BiddingExecutionResultWorkflowSelection"> & {
  /**
   * @generated from field: repeated string workflow_ids = 1;
   */
  workflowIds: string[];

  /**
   * @generated from field: bool include_no_workflow = 2;
   */
  includeNoWorkflow: boolean;
};

/**
 * Describes the message bffuser.v1.BiddingExecutionResultWorkflowSelection.
 * Use `create(BiddingExecutionResultWorkflowSelectionSchema)` to create a new message.
 */
export const BiddingExecutionResultWorkflowSelectionSchema: GenMessage<BiddingExecutionResultWorkflowSelection> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_execution_result_model, 1);

/**
 * BiddingExecutionResultLine は internalapi.v1.ExecutionResultLine の mirror (field 番号を一致させる)。
 * スポット・時間前で共通の約定結果 CSV の 1 行
 * (AC-BSP-115)。 通常入札は 1 札 = 1 行、 ブロック入札は Leg × コマ = 1 行。
 * 未約定の行は matched_price_yen_per_kwh を持たず、 約定数量・約定電力量・約定金額は 0。
 * 約定済みで約定価格が未取得の行は matched_price_yen_per_kwh・matched_amount_yen を持たない (CSV は空欄)。
 * 円の列と約定電力量は丸めない。
 *
 * @generated from message bffuser.v1.BiddingExecutionResultLine
 */
export type BiddingExecutionResultLine = Message<"bffuser.v1.BiddingExecutionResultLine"> & {
  /**
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 koma = 2;
   */
  koma: number;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: optional string delivery_contract_code = 4;
   */
  deliveryContractCode?: string;

  /**
   * @generated from field: bffuser.v1.BiddingExecutionResultBidKind bid_kind = 5;
   */
  bidKind: BiddingExecutionResultBidKind;

  /**
   * @generated from field: bfftypes.v1.Side side = 6;
   */
  side: Side;

  /**
   * @generated from field: google.type.Decimal bid_price_yen_per_kwh = 7;
   */
  bidPriceYenPerKwh?: Decimal;

  /**
   * @generated from field: google.type.Decimal bid_volume_mw = 8;
   */
  bidVolumeMw?: Decimal;

  /**
   * @generated from field: bffuser.v1.BiddingExecutionResultStatus status = 9;
   */
  status: BiddingExecutionResultStatus;

  /**
   * @generated from field: optional google.type.Decimal matched_price_yen_per_kwh = 10;
   */
  matchedPriceYenPerKwh?: Decimal;

  /**
   * @generated from field: google.type.Decimal matched_volume_mw = 11;
   */
  matchedVolumeMw?: Decimal;

  /**
   * = matched_volume_mw × 0.5。
   *
   * @generated from field: google.type.Decimal matched_energy_mwh = 12;
   */
  matchedEnergyMwh?: Decimal;

  /**
   * = bid_volume_mw − matched_volume_mw。
   *
   * @generated from field: google.type.Decimal remaining_volume_mw = 13;
   */
  remainingVolumeMw?: Decimal;

  /**
   * = matched_price_yen_per_kwh × matched_energy_mwh × 1000。 約定価格が未取得なら未設定。
   *
   * @generated from field: optional google.type.Decimal matched_amount_yen = 14;
   */
  matchedAmountYen?: Decimal;

  /**
   * @generated from field: optional string jepx_bid_no = 15;
   */
  jepxBidNo?: string;

  /**
   * @generated from field: optional string created_by = 16;
   */
  createdBy?: string;

  /**
   * @generated from field: optional string workflow_id = 17;
   */
  workflowId?: string;

  /**
   * @generated from field: optional string memo_jepx = 18;
   */
  memoJepx?: string;

  /**
   * @generated from field: optional string memo_free = 19;
   */
  memoFree?: string;
};

/**
 * Describes the message bffuser.v1.BiddingExecutionResultLine.
 * Use `create(BiddingExecutionResultLineSchema)` to create a new message.
 */
export const BiddingExecutionResultLineSchema: GenMessage<BiddingExecutionResultLine> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_execution_result_model, 2);

/**
 * 約定結果 CSV の入札種別列 (spot-bidding.md AC-BSP-115)。 通常入札は NORMAL、
 * ブロック入札は Leg の種別。
 *
 * @generated from enum bffuser.v1.BiddingExecutionResultBidKind
 */
export enum BiddingExecutionResultBidKind {
  /**
   * @generated from enum value: BIDDING_EXECUTION_RESULT_BID_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_EXECUTION_RESULT_BID_KIND_NORMAL = 1;
   */
  NORMAL = 1,

  /**
   * @generated from enum value: BIDDING_EXECUTION_RESULT_BID_KIND_BLOCK = 2;
   */
  BLOCK = 2,

  /**
   * @generated from enum value: BIDDING_EXECUTION_RESULT_BID_KIND_LINK_BLOCK_P = 3;
   */
  LINK_BLOCK_P = 3,

  /**
   * @generated from enum value: BIDDING_EXECUTION_RESULT_BID_KIND_LINK_BLOCK_C = 4;
   */
  LINK_BLOCK_C = 4,

  /**
   * @generated from enum value: BIDDING_EXECUTION_RESULT_BID_KIND_LOOP_BLOCK_A = 5;
   */
  LOOP_BLOCK_A = 5,

  /**
   * @generated from enum value: BIDDING_EXECUTION_RESULT_BID_KIND_LOOP_BLOCK_B = 6;
   */
  LOOP_BLOCK_B = 6,
}

/**
 * Describes the enum bffuser.v1.BiddingExecutionResultBidKind.
 */
export const BiddingExecutionResultBidKindSchema: GenEnum<BiddingExecutionResultBidKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_execution_result_model, 0);

/**
 * 約定結果 CSV に出る札の約定結果 (AC-BSP-115: 全約定 / 部分約定 / 未約定)。
 *
 * @generated from enum bffuser.v1.BiddingExecutionResultStatus
 */
export enum BiddingExecutionResultStatus {
  /**
   * @generated from enum value: BIDDING_EXECUTION_RESULT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_EXECUTION_RESULT_STATUS_ALL_MATCHED = 1;
   */
  ALL_MATCHED = 1,

  /**
   * @generated from enum value: BIDDING_EXECUTION_RESULT_STATUS_PARTIALLY_MATCHED = 2;
   */
  PARTIALLY_MATCHED = 2,

  /**
   * @generated from enum value: BIDDING_EXECUTION_RESULT_STATUS_UNMATCHED = 3;
   */
  UNMATCHED = 3,
}

/**
 * Describes the enum bffuser.v1.BiddingExecutionResultStatus.
 */
export const BiddingExecutionResultStatusSchema: GenEnum<BiddingExecutionResultStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_execution_result_model, 1);

/**
 * 約定結果が未着の札 (AC-BSP-101) が約定結果タブのステータス列に出る区分 (AC-BSP-047):
 * JEPX が受け付けた札は約定待ち、 受け付けたか確かめられていない札 (再送中・受付確認中) は送信中。
 *
 * @generated from enum bffuser.v1.BiddingExecutionResultUnarrivedStatus
 */
export enum BiddingExecutionResultUnarrivedStatus {
  /**
   * @generated from enum value: BIDDING_EXECUTION_RESULT_UNARRIVED_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_EXECUTION_RESULT_UNARRIVED_STATUS_AWAITING_MATCH = 1;
   */
  AWAITING_MATCH = 1,

  /**
   * @generated from enum value: BIDDING_EXECUTION_RESULT_UNARRIVED_STATUS_SENDING = 2;
   */
  SENDING = 2,
}

/**
 * Describes the enum bffuser.v1.BiddingExecutionResultUnarrivedStatus.
 */
export const BiddingExecutionResultUnarrivedStatusSchema: GenEnum<BiddingExecutionResultUnarrivedStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_execution_result_model, 2);

